import React, { useContext } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import Utility from '../../../Utility';
import { Card, Image, Icon, Statistic } from 'semantic-ui-react';
import { Link } from "react-router-dom";
import AmountProvider from '../../Provider/AmountProvider';
import MomentCustomer from '../../MomentCustomer/MomentCustomer';
import './Booking.css';

/**
 * Components Booking
 * Widget pour le dashboard
 * @param {object} props.booking
 * @param {string} props.image
 */
const Booking = props => {
  const [globalContext] = useContext(GlobalContext);
  const siteMap = Utility.getSiteMap(globalContext.translations);
  const getLabelData = (state) => {
    let textLabel = '';
    let colorLabel = '';
    switch (state) {
      case "active":
        textLabel = globalContext.translations.bookingStatusActive;
        colorLabel = "green";
        break;
      case "passed":
        textLabel = globalContext.translations.bookingStatusPassed;
        colorLabel = "yellow";
        break;
      case "future":
        textLabel = globalContext.translations.bookingStatusFuture;
        colorLabel = "blue";
        break;
      case "pending":
        textLabel = globalContext.translations.bookingsStatusPending;
        colorLabel = "orange";
        break;

      default:
        textLabel = globalContext.translations.preCheckInCancel;
        colorLabel = "red";
        break;
    }
    return [textLabel, colorLabel];
  };


  // trad title card
  let titleCard = globalContext.translations.stayFrom
  if ( globalContext.espaceClientByOrga && Object.keys(globalContext.establishmentCollection).length > 0 ) {
    titleCard = globalContext.translations.titleCardStayInHostel + ' - ' + globalContext.establishmentCollection[props.booking.establishmentId]?.name
  }
  

  const [textLabel, colorLabel] = getLabelData(props.booking.state);

  return (
    <Card
      style={{ height: "300px" }}
      centered
      as={Link}
      to={{
        pathname: `${Utility.getUrlBaseName()}/${siteMap.bookings.codePage}/${props.booking.id}`,
        state: { folderId: props.booking.id, folderNumber: props.booking.number }
      }}
      onClick={() => props.setActiveItemMenu(siteMap.bookings.codePage)}
    >
      <Card.Header style={{height:'169px'}}>
        <Image
          className="imageCard"
          label={{
            color: colorLabel,
            content: textLabel,
            icon: 'hotel',
            ribbon: 'right',
          }}
          src={Utility.imageExists(props.image, 'cardDashboard')}
          ui={true}
        />
      </Card.Header>
      <Card.Content>
        <Card.Header>{titleCard}</Card.Header>
        <Card.Description style={{ fontSize: '0.9em', fontWeight: '500' }}>
          <Icon className="mr-1 mbBlue" name="calendar alternate" />
          <span className="mr-1">{<MomentCustomer format="Do MMM YYYY">{props.booking.arrivalDate}</MomentCustomer>}</span>
          <Icon name="long arrow alternate right" className="mbBlue" />
          <span className="">{<MomentCustomer format="Do MMM YYYY">{props.booking.departureDate}</MomentCustomer>}</span>
        </Card.Description>

      </Card.Content>
      <Card.Content extra style={{ height: 58 }}>
        <div style={{ marginTop: 7 }}>
          <span className="mr-4"><Icon name="user" className="mbBlue" />{props.booking.paxTotal}</span>
          <Statistic className="m-0" size="mini" floated="right">
            <Statistic.Value>
              {
                // total dossier
                props.booking?.noteSecondaire ?
                <AmountProvider amount={props.booking.totalExtraPresta} currency={props.booking.currency} />
                :
                <AmountProvider amount={props.booking.servicesTotalAmount} currency={props.booking.currency} />
              }
            </Statistic.Value>
          </Statistic>
        </div>
      </Card.Content>
    </Card>
  );
}

export default Booking;